import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="contact"
export default class extends Controller {
  static targets = ["tableData", "addressBookContact", "destroyField", "addressBookId", "idField", "primaryCheckbox", "addressBookSelectedId"]

  getTargets() {
    return  [
        this.tableDataTargets, 
        this.addressBookContactTargets, 
        this.hasDestroyFieldTarget ? this.destroyFieldTarget : null, 
        this.addressBookIdTarget.value,
        this.hasIdFieldTarget ? this.idFieldTarget : null
    ]
  }

  setDisabledPrimaryCheckbox(state) {
    if(this.hasPrimaryCheckboxTarget) {
      this.primaryCheckboxTarget.disabled = state
    }
  }
}
